import Reset from './components/Reset';
import ResetMain from './components/ResetMain';
export default {
	Reset,
	ResetMain
}